<template>
  <div>
      <div v-show="Qtxzgl_detailed_add">
        <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">其他险种管理-明细-{{ruleForm.id != null && ruleForm.id != '' ? '修改' : '新增'}}</div>
        <el-button style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;" @click="Return">返回</el-button>

        <!-- 主体 -->
    <div style="height:540px;background-color:white;margin:75px 40px 0 40px;padding:100px;overflow-x: hidden">
      <!-- 查询框 -->
      <div v-for="(item, index) in ruleForm.insuranceList" :key="index">
          <span style="color:#006E4B;font-weight:900;font-size:20px">|   </span>
      <span style="font-size:20px;font-weight:700">明细{{index + 1}}</span>
      <img src="../../../assets/icon/减少.png" v-show="index != 0"
                            style="float: right; margin-right: 20px;" width="25px" @click="delTtinerary(index)" />
      <div style="border:1px solid #DADADA;margin-top:10px"></div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm"> 
            <el-row>
                <el-col :span="12">
                <el-form-item label="保单名称" prop="insurance_name" style="margin-top:40px;width:80%">
                    <el-input :disabled="true" v-model="$parent.ruleForm.insurance_name"></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="保单号" prop="policy_no" style="margin-top:40px;width:80%">
                    <el-input :disabled="true" v-model="$parent.ruleForm.policy_no"></el-input>
                </el-form-item>
                </el-col> 
            </el-row>
            
            <el-row>
                <el-col :span="12">
                <!-- <el-form-item label="所属项目" prop="project_id" >			
			<el-cascader v-model="insuranceList[index].project_ids" :options="organizeList" clearable
			    style="width: 80%;" collapse-tags :props="props" @change="projectChange(index)"></el-cascader>
                </el-form-item> -->
                <el-form-item label="所属项目" prop="organize_temporary_ids" style="width:80%" >
								<el-cascader v-model="insuranceList[index].organize_temporary_ids" @change="changeCascader"
									style="width:100%" collapse-tags :props="props" :show-all-levels="false">
								</el-cascader>
							</el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="唯一识别码" prop="unique_id" style="width:80%">
                    <el-input v-model="insuranceList[index].unique_id" placeholder="请输入唯一识别码"></el-input>
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                <el-form-item label="投保数量" prop="insure_number" style="width:80%">
                    <el-input v-model="insuranceList[index].insure_number" placeholder="请输入投保数量"></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="名称/品牌" prop="brand" style="width:80%">
                    <el-input v-model="insuranceList[index].brand" placeholder="请输入名称/品牌"></el-input>
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                <el-form-item label="规格/型号" prop="model" style="width:80%">
                    <el-input v-model="insuranceList[index].model" placeholder="请输入规格/型号"></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="费用金额" prop="cost" style="width:80%">
                   <el-input v-model="insuranceList[index].cost" placeholder="请输入费用金额"></el-input>
                </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                <el-form-item label="生效时间" required>
                    <el-col :span="9">
                    <el-form-item prop="start_date">
                        <el-date-picker type="date" placeholder="请选择" v-model="insuranceList[index].start_date" value-format="yyyy-MM-dd" style="width:85%"></el-date-picker>
                    </el-form-item>
                    </el-col>
                    <el-col class="line" :span="1"> - </el-col>
                    <el-col :span="9">
                    <el-form-item prop="end_date">
                        <el-date-picker type="date" placeholder="请选择" v-model="insuranceList[index].end_date" value-format="yyyy-MM-dd" style="width:85%"></el-date-picker>
                    </el-form-item>
                    </el-col>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="付款时间" prop="payment_date">
                    <el-date-picker v-model="insuranceList[index].payment_date" type="datetime" style="width:73%" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择付款时间"></el-date-picker>
                </el-form-item>
                </el-col>
            </el-row>

            <el-form-item label="备注" prop="remarks" style="width:90%">
                <el-input v-model="insuranceList[index].remarks" placeholder="请输入备注"></el-input>
            </el-form-item>

            <el-row>
                <el-col :span="12">
                <el-form-item label="批改扫描件" prop="copy_url">
                    <el-upload :action="$globals.http + 'file/upload'" list-type="picture-card"
                    :on-preview="handlePictureCardPreview" :limit="1" :on-remove="handleRemove" :file-list="insuranceList[index].copy_url"
                    :on-success="handleAvatarSuccess">
                    <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="insuranceList[index].copy_url" alt="">
                    </el-dialog>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="上传附件" prop="enclosure_url" style="width:80%">
                    <el-upload
                    class="upload-demo"
                    :action="$globals.http + '/file/upload'" 
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :on-success="uploadFujian"
                    :before-remove="beforeRemove"
                    multiple
                    :on-exceed="handleExceed"
                    :file-list="insuranceList[index].enclosure_url"    
                    :v-model="insuranceList[index].enclosure_url"
                  >
                <el-button type="goon" style="font-size:10px;width:100px" >上传附件</el-button>
                </el-upload>
                </el-form-item>
                </el-col>
            </el-row>

            <div style="margin-left:5%">
                <img src="../../../assets/icon/添加明细.png" @click="AddTtinerary"
                    v-show="index === (ruleForm.insuranceList.length - 1) && (ruleForm.id == null || ruleForm.id == '')">
            </div>
        </el-form>
      </div>
      <div style="margin-left:45%;margin-top:50px">
            <el-button type="goon" @click="submitForm()" v-show="ruleForm.id == null || ruleForm.id == ''">保存</el-button>
            <el-button type="goon" @click="Update()" v-show="ruleForm.id != null && ruleForm.id != ''">修改</el-button>

      </div>

      </div>
      
    </div>
  </div>
</template>

<script>
export default {
	props:["organizeList"],
    data() {
      var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
      return {
        Qtxzgl_detailed_add:true,
        imageUrl: '',
        textarea:'',
        xmList:[],
        
        ruleForm: {
          id:'',
          organize_temporary_ids:'',
            insuranceList:[{
				id: '',
                insurance_id:'',
                insurance_name:'',
                policy_no:'',
				organize_ids: '',
                project_id:'',
                unique_id:'',
                insure_number:'',
                brand:'',
                model:'',
                cost:'',
                start_date:'',
                end_date:'',
                payment_date:'',
                remarks:'',
                copy_url:'',
                enclosure_url:'',
            }],
            insurance:{
                insurance_id:'',
                insurance_name:'',
                policy_no:'',
                insurance_name:'',
				project_ids:[],
                project_id:'',
				organize_ids: '',
                unique_id:'',
                insure_number:'',
                brand:'',
                model:'',
                cost:'',
                start_date:'',
                end_date:'',
                payment_date:'',
                remarks:'',
                copy_url:'',
                enclosure_url:'',
            }      
        },
        insuranceList:[{
            insurance_id:'',
            insurance_name:'',
            policy_no:'',
            insurance_name:'',
            project_ids:[],
			project_id:'',
			organize_ids: '',
            unique_id:'',
            insure_number:'',
            brand:'',
            model:'',
            cost:'',
            start_date:'',
            end_date:'',
            payment_date:'',
            remarks:'',
            copy_url:'',
            enclosure_url:'',
            }],
        rules: {
          name: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
          ],
        },
		//组织架构数据
				organizeList: [],

				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: false,
				},
      };
    },
    methods: {
      //项目选择
			changeCascader() {
				this.ruleForm.organize_ids = '';
				this.ruleForm.insuranceList.project_id = this.ruleForm.organize_temporary_ids[this.
					ruleForm.organize_temporary_ids.length - 1][0];
					// this.ruleForm.organize_temporary_ids = this.ruleForm.organize_temporary_ids[this.
					// ruleForm.organize_temporary_ids.length - 1];
			},
      //初始化组织架构及下面的人
			async organizeFind() {
				var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
					identification: "1",
					id: this.condition.project_id
				});
				this.organizeList = this.getTreeData(organizeList.data);
			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			},
		// projectChange(index){
		// 	this.insuranceList[index].organize_ids = '';
		// 	this.insuranceList[index].project_ids.forEach(item => {
		// 		this.insuranceList[index].organize_ids += "," + item
		// 	})
		// 	this.insuranceList[index].project_id = this.insuranceList[index].project_ids[this.insuranceList[index].project_ids.length - 1];
		// },
      async submitForm() {
          var url = 'InsuranceDetailed/insert';
          this.ruleForm.insuranceList = this.insuranceList;
          var record = {
            insurance_id: this.$parent.ruleForm.insurance_id,
            insurance_name: this.$parent.ruleForm.insurance_name,
            policy_no: this.$parent.ruleForm.policy_no,
			
            insuranceList: this.ruleForm.insuranceList,
			// 'insuranceList.project_id': this.ruleForm.insuranceList.organize_temporary_ids
          };
          var data = await this.$globals.AxiosPost(url, record);
          if (data === '-2000') {
              this.$message.error('服务器未响应！请稍后重试');
          } else {
              var code = data.code;
              var data = data.data;
              if (code === '200') {
                  this.$message.success(data);
                  this.Return();
              } else {
                  this.$message.warning(data);
              }
          }

    },
    // 修改
    async Update() {
          var url = '/InsuranceDetailed/update';
          this.ruleForm.insuranceList = this.insuranceList;
          var record = {
			  id: this.ruleForm.insuranceList[0].id,
            insurance_id: this.$parent.ruleForm.insurance_id,
            insurance_name: this.$parent.ruleForm.insurance_name,
            policy_no: this.$parent.ruleForm.policy_no,
			organize_ids: this.ruleForm.insuranceList[0].organize_ids,
            project_id: this.ruleForm.insuranceList[0].project_id,
			unique_id: this.ruleForm.insuranceList[0].unique_id,
			insure_number: this.ruleForm.insuranceList[0].insure_number,
			brand: this.ruleForm.insuranceList[0].brand,
			model: this.ruleForm.insuranceList[0].model,
			cost: this.ruleForm.insuranceList[0].cost,
			start_date: this.ruleForm.insuranceList[0].start_date,
			end_date: this.ruleForm.insuranceList[0].end_date,
			payment_date: this.ruleForm.insuranceList[0].payment_date,
			remarks: this.ruleForm.insuranceList[0].remarks,
			copy_url: this.ruleForm.insuranceList[0].copy_url,
			enclosure_url: this.ruleForm.insuranceList[0].enclosure_url,
          };
          var data = await this.$globals.AxiosPost(url, record);
          if (data === '-2000') {
              this.$message.error('服务器未响应！请稍后重试');
          } else {
              var code = data.code;
              var data = data.data;
              if (code === '200') {
                  this.$message.success(data);
                  this.Return();
              } else {
                  this.$message.warning(data);
              }
          }

    },
      Return(){
        this.$parent.Qtxzgl_detailed = true;
        this.$parent.showadd = false;
        this.$parent.trash();
        this.$parent.Find();
      },
      //添加明细
      AddTtinerary() {
        this.ruleForm.insuranceList.push(this.ruleForm.insurance);
        this.insuranceList.push(this.ruleForm.insurance);
      },
      //减少明细
        delTtinerary(e) {
            this.ruleForm.insuranceList.splice(e, 1);
            this.insuranceList.splice(e, 1);
        },
    //   handleAvatarSuccess(res, file) {
    //     this.insuranceList[index].copy_url = res.data.fileUrl;
    //   },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      }, 
    //   uploadFujian(res, file) {
    //    this.insuranceList[index].enclosure_url = res.data.fileUrl;
    //   },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
    },
    watch: {
      "ruleForm.id"(){
        this.ruleForm;
      }
    },
    async created() {
      this.ruleForm = this.$parent.ruleForm;
      // 项目
    var xmList = await this.$globals.AxiosPost("project/selectFind", {});
    this.xmList = xmList.data;
    },
  }
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

</style>


// WEBPACK FOOTER //
// Qtxzgl_detailed_add.vue?e1d4fd08